import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import withMessages, { FormattedMessage } from 'component-utilities/intl';
import { formatDate, DATE_FORMATS } from 'component-utilities/dates/dates';

import styles from '../Modals.scss';
import filterStyles from '../../Dropdowns/Filter/Filter.scss';

import ModalContainer from '../ModalContainer';
import ModalHeader from '../ModalHeader';
import ModalContentLeft from '../ModalContentLeft';
import SecondaryButton from '../../Buttons/PrimaryButton';
import PrimaryButton from '../../Buttons/SecondaryButton';
import ModalButtonSpacer from '../ModalButtonSpacer';
import FormRow from '../../Dropdowns/Filter/Components/FormRow';
import SelectGenerator from '../../Forms/Selects-v2/SelectGenerator';
import SelectMultiSelectGenerator from '../../Forms/Selects-v2/SelectMultiSelectGenerator';
import InputFieldV2 from '../../Forms/InputFields/InputFieldV2';
import CalendarSearch from '../../Calendar/CalendarSearch';

import {
    ATTACHMENT_TYPES,
    SIZE_TYPES,
    FORM_FIELDS,
    DATE_TYPES,
} from '../../Dropdowns/Filter/config';

import toggleInArray from '../../../lib/toggleInArray';
import isBlank from '../../../lib/isBlank';

const PERSONAL_ARCHIVE_BASE_KEY = 'components.personal_archive';
const SEARCH_FIELD_BASE_KEY = 'components.dropdowns.filter';

const SelectSmall = SelectGenerator('small', filterStyles);
const SelectMedium = SelectGenerator('medium', filterStyles);
const SelectMediumMultiSelect = SelectMultiSelectGenerator('medium', filterStyles);

export { FORM_FIELDS, ATTACHMENT_TYPES, SIZE_TYPES, DATE_TYPES };

const { ATTACHMENTS, KEYWORDS, PARTICIPANTS, SENDER, DATE, SIZE } = FORM_FIELDS;

@withMessages
export default class PersonalArchiveModals extends Component {
    static propTypes = {
        onCancel: PropTypes.func.isRequired,
        getMessage: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
        onSave: PropTypes.func,
        onDelete: PropTypes.func,
        onModify: PropTypes.func,
        formValues: PropTypes.object.isRequired,
        isNewPersonalSearchModal: PropTypes.bool,
        searchName: PropTypes.object,
        keywords: PropTypes.object,
        from: PropTypes.object,
        participants: PropTypes.object,
        dates: PropTypes.object,
        attachments: PropTypes.object,
        sizes: PropTypes.object,
    };

    static defaultProps = {
        searchName: {},
        keywords: {},
        from: {},
        participants: {},
        dates: {},
        sizes: {},
        attachments: {},
        isNewPersonalSearchModal: false,
        onDelete: () => {},
        onModify: () => {},
        onSave: () => {},
    };

    constructor(props) {
        super(props);

        this.state = {
            searchName: props.formValues.searchName || { value: {} },
            keywords: props.formValues.keywords || { value: {} },
            from: props.formValues.from || { value: {} },
            participants: props.formValues.participants || { value: {} },
            attachments: props.formValues.attachments || {},
            sizes: props.formValues.sizes || [],
            dates: props.formValues.dates || {},
        };
    }

    onChange = type => e => this.setState({ [type]: { value: { query: e.target.value } } });

    onSelectionChange = (selectionField, selectionValue) => (newValue) => {
        const newSelectionValues = { [selectionValue]: newValue };

        if (selectionField === FORM_FIELDS.ATTACHMENTS) {
            const localizedData = this.getLocalizedData(FORM_FIELDS.ATTACHMENTS, ATTACHMENT_TYPES);

            newSelectionValues.localizedValue = (localizedData.find(data => data.id === newValue) || {}).value || '';

            this.setState({
                attachments: {
                    ...this.state.attachments,
                    ...newSelectionValues,
                },
            });
        }

        if (selectionField === FORM_FIELDS.SIZE) {
            const localizedData = this.getLocalizedData(FORM_FIELDS.SIZE, SIZE_TYPES);

            newSelectionValues.localizedValue = newValue.map(value => (localizedData.find(data => data.id === value) || {}).value || '');

            this.setState({
                sizes: {
                    ...this.state.sizes,
                    ...newSelectionValues,
                },
            });
        }

        if (selectionField === FORM_FIELDS.DATE && (selectionValue === 'type' || selectionValue === 'from' || selectionValue === 'to')) {
            const localizedData = this.getLocalizedData(FORM_FIELDS.DATE, DATE_TYPES);

            newSelectionValues.localizedValue = (localizedData.find(data => data.id === newValue) || {}).value || '';

            if (newValue !== DATE_TYPES.RANGE) {
                newSelectionValues.to = '';
            }

            if (!newValue.length) {
                newSelectionValues.from = '';
            }

            // set the empty state once date criteria is removed
            if (!newSelectionValues.localizedValue && !newSelectionValues.from && selectionValue !== 'to') {
                this.setState({
                    dates: { value: {} },
                });
            } else {
                switch (selectionValue) {
                case 'type' : this.setState({
                    dates: {
                        ...this.state.dates,
                        ...newSelectionValues,
                    },
                });
                    break;
                case 'from' : this.setState({
                    dates: {
                        ...this.state.dates,
                        from: newValue,
                    },
                });
                    break;
                case 'to' : this.setState({
                    dates: {
                        ...this.state.dates,
                        to: newValue,
                    },
                });
                    break;
                default: this.setState({
                    dates: {
                        ...this.state.dates,
                        ...newSelectionValues,
                    },
                });
                }
            }
        }
    };

    onMultiSelect = (field, value) => (selectedValue) => {
        let previousValues = [];

        if (this.state.sizes.query === undefined) {
            previousValues = [];
        } else {
            previousValues = this.state.sizes.query;
        }

        this.onSelectionChange(field, value)(toggleInArray(previousValues || [], selectedValue));
    };


    getLocalizedData = (type, dataTypes) => Object.keys(dataTypes).map(key => ({
        id: dataTypes[key],
        value: this.props.getMessage(`${SEARCH_FIELD_BASE_KEY}.${type}.${dataTypes[key]}`),
    }));

    get isRangeDate() {
        return ((this.state.dates || {}).type === DATE_TYPES.RANGE);
    }

    clearAll = () => {
        this.setState({
            searchName: { value: {} },
            keywords: { value: {} },
            from: { value: {} },
            participants: { value: {} },
            dates: { value: {} },
            attachments: { value: {} },
            sizes: { value: {} },
        });
    };

    isButtonDisabled() {
        const textFields = [KEYWORDS, SENDER, PARTICIPANTS];
        const otherFields = [ATTACHMENTS, SIZE];
        const dateField = [DATE];
        let searchNamePopulated = false;
        let searchCriteriaPopulated = false;
        let searchDateCriteria = false;

        if (this.state.searchName.value.query && !isBlank(this.state.searchName.value.query)) {
            searchNamePopulated = true;
        }

        Object.keys(this.state).map((mappedState) => {
            const textFieldCheck = textFields.includes(mappedState) &&
              this.state[mappedState].value.query &&
              !isBlank(this.state[mappedState].value.query);
            const otherFieldCheck = otherFields.includes(mappedState) &&
              !isEmpty(this.state[mappedState].query);
            const dateFieldCheck = dateField.includes(mappedState) &&
              !isEmpty(this.state[mappedState].localizedValue) &&
              !isEmpty(this.state[mappedState].to || this.state[mappedState].from);

            if (textFieldCheck || otherFieldCheck || dateFieldCheck) searchCriteriaPopulated = true;
            searchDateCriteria = dateFieldCheck;

            return mappedState;
        });

        if (searchCriteriaPopulated && !searchDateCriteria) {
            if (this.state.dates.localizedValue) {
                searchCriteriaPopulated = false;
            }
        }
        return !(searchNamePopulated && searchCriteriaPopulated);
    }

    saveSearch = () => {
        this.props.onSave(this.state);
    };

    modifySearch = () => {
        this.props.onModify(this.state);
    };

    deleteSearch = () => {
        this.props.onDelete(this.state);
    };

    render() {
        const {
            onCancel,
            onClose,
            getMessage,
            isNewPersonalSearchModal,
        } = this.props;

        return (
            <ModalContainer>
                <ModalHeader className={styles['modal-header-normal']} onCloseClick={onClose}>
                    {isNewPersonalSearchModal
                        ? <FormattedMessage id={`${PERSONAL_ARCHIVE_BASE_KEY}.new_search_modal`} />
                        : <FormattedMessage id={`${PERSONAL_ARCHIVE_BASE_KEY}.edit_search_modal`} /> }
                </ModalHeader>
                <ModalContentLeft>
                    <span className={filterStyles['filter-tool']}>
                        <FormRow required label={getMessage(`${PERSONAL_ARCHIVE_BASE_KEY}.search_name`)}>
                            <InputFieldV2
                                data-field="search-name"
                                value={this.state.searchName.value.query || ''}
                                onChange={this.onChange('searchName')}
                            />
                        </FormRow>
                        <FormRow label={getMessage(`${SEARCH_FIELD_BASE_KEY}.labels.${KEYWORDS}`)}>
                            <InputFieldV2
                                data-field={KEYWORDS}
                                value={this.state.keywords.value.query || ''}
                                onChange={this.onChange(KEYWORDS)}
                            />
                        </FormRow>
                        <FormRow label={getMessage(`${SEARCH_FIELD_BASE_KEY}.labels.${SENDER}`)}>
                            <InputFieldV2
                                data-field={SENDER}
                                value={this.state.from.value.query || ''}
                                onChange={this.onChange(SENDER)}
                            />
                        </FormRow>
                        <FormRow label={getMessage(`${SEARCH_FIELD_BASE_KEY}.labels.${PARTICIPANTS}`)}>
                            <InputFieldV2
                                data-field={PARTICIPANTS}
                                value={this.state.participants.value.query || ''}
                                onChange={this.onChange(PARTICIPANTS)}
                            />
                        </FormRow>
                        <FormRow label={getMessage(`${SEARCH_FIELD_BASE_KEY}.labels.${DATE}`)}>
                            <SelectSmall
                                id="date_select"
                                onSelect={this.onSelectionChange(DATE, 'type')}
                                selectedId={this.state.dates.type}
                                data={this.getLocalizedData(DATE, DATE_TYPES)}
                                placeholder={getMessage(`${SEARCH_FIELD_BASE_KEY}.placeholders.dates`)}

                            />
                            {!!this.state.dates.type && (
                                <span className={filterStyles['dropdown-calendar']}>
                                    <input
                                        type="text"
                                        className={filterStyles['input-field']}
                                        name="start-date"
                                        maxLength={8}
                                        data-field={`${DATE}-from`}
                                        placeholder={this.isRangeDate ? 'Start date' : 'Date'}
                                        value={
                                            this.state.dates.from
                                                ? formatDate(this.state.dates.from, DATE_FORMATS.SHORT)
                                                : ''
                                        }
                                        readOnly
                                    />
                                    <span className={filterStyles['icon-calendar']} />
                                    <span className={filterStyles['dropdown-box']} >
                                        <CalendarSearch
                                            onDateSelected={this.onSelectionChange(DATE, 'from')}
                                            selectedDate={this.state.dates.from}
                                            maxDate={this.isRangeDate ? this.state.dates.to : null}
                                        />
                                    </span>
                                </span>
                            )}
                            {this.isRangeDate && <span className={filterStyles['date-range-to']}>
                                to
                            </span> }
                            {this.isRangeDate && (
                                <span className={filterStyles['dropdown-calendar']}>
                                    <input
                                        type="text"
                                        className={filterStyles['input-field']}
                                        name="end-date"
                                        maxLength={8}
                                        data-field={`${DATE}-to`}
                                        placeholder="End Date"
                                        value={
                                            this.state.dates.to ? formatDate(this.state.dates.to, DATE_FORMATS.SHORT) : ''
                                        }
                                        readOnly
                                    />
                                    <span className={filterStyles['icon-calendar']} />
                                    <span className={filterStyles['dropdown-box']}>
                                        <CalendarSearch
                                            onDateSelected={this.onSelectionChange(DATE, 'to')}
                                            selectedDate={this.state.dates.to}
                                            minDate={this.state.dates.from}
                                        />
                                    </span>
                                </span>
                            )}
                        </FormRow>
                        <FormRow label={getMessage(`${SEARCH_FIELD_BASE_KEY}.labels.${ATTACHMENTS}`)}>
                            <div data-field={ATTACHMENTS}>
                                <SelectMedium
                                    id="attachment-field"
                                    placeholder={getMessage(`${SEARCH_FIELD_BASE_KEY}.placeholders.attachment`)}
                                    onSelect={this.onSelectionChange(ATTACHMENTS, 'query')}
                                    selectedId={this.state.attachments.query}
                                    data={this.getLocalizedData(ATTACHMENTS, ATTACHMENT_TYPES)}
                                />
                            </div>
                        </FormRow>
                        <FormRow label={getMessage(`${SEARCH_FIELD_BASE_KEY}.labels.${SIZE}`)}>
                            <div data-field={SIZE}>
                                <SelectMediumMultiSelect
                                    id="size-field"
                                    placeholder={getMessage(`${SEARCH_FIELD_BASE_KEY}.placeholders.size`)}
                                    onSelect={this.onMultiSelect(SIZE, 'query')}
                                    selectedIds={this.state.sizes.query || []}
                                    data={this.getLocalizedData(SIZE, SIZE_TYPES)}
                                />
                            </div>
                        </FormRow>
                    </span>
                </ModalContentLeft>
                <div className={styles['modal-buttons']}>
                    <span className={styles['buttons-left']}>
                        {isNewPersonalSearchModal &&
                        <SecondaryButton
                            onClick={() => this.saveSearch()}
                            disabled={this.isButtonDisabled()}
                        >
                            <FormattedMessage id={`${PERSONAL_ARCHIVE_BASE_KEY}.save`} />
                        </SecondaryButton>
                        }
                        {!isNewPersonalSearchModal &&
                        <SecondaryButton
                            onClick={() => this.modifySearch()}
                            disabled={this.isButtonDisabled()}
                        >
                            <FormattedMessage id={`${PERSONAL_ARCHIVE_BASE_KEY}.apply`} />
                        </SecondaryButton>
                        }
                        <ModalButtonSpacer />
                        <PrimaryButton onClick={this.clearAll}>
                            <FormattedMessage id={`${PERSONAL_ARCHIVE_BASE_KEY}.clear`} />
                        </PrimaryButton>
                    </span>
                    <span className={styles['buttons-right']}>
                        {isNewPersonalSearchModal &&
                        <PrimaryButton onClick={onCancel}>
                            <FormattedMessage id={`${PERSONAL_ARCHIVE_BASE_KEY}.cancel`} />
                        </PrimaryButton>
                        }
                        {!isNewPersonalSearchModal &&
                        <PrimaryButton onClick={() => this.deleteSearch()}>
                            <FormattedMessage id={`${PERSONAL_ARCHIVE_BASE_KEY}.delete`} />
                        </PrimaryButton>
                        }
                    </span>
                </div>
            </ModalContainer>
        );
    }
}
